module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1016-887fad5af5046859b48bc16695e01aa7.png";